import { setValueOnDotPath } from '@asamco/utils';

export function printMissingTranslationKeys(): void {
	// Export function to print missing translation keys
	window['printMissingTranslationKeys'] = () => {
		const obj = {};
		window['missing-translation'].forEach((tk: string) => {
			setValueOnDotPath(obj, tk, '');
		});

		console.log(obj); // NOSONAR
		console.log(JSON.stringify(obj)); // NOSONAR
	};
}
